<template>
  <div class="applyForBox">
    <div class="applyForMain">
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>申请服务</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <div class="applyForCon">
        <el-table
          ref="multipleTable"
          header-cell-class-name="cellCustomer headerCellCustomer ft14"
          cell-class-name="cellCustomer ft12"
          :data="tableData"
          border
          tooltip-effect="dark"
          @select="handleSelectionChange"
        >
          <template slot="empty">
            <img class="data-pic" src="../../../assets/images/H5/null.png" alt>
            <br>暂无数据
          </template>
          <el-table-column type="selection"></el-table-column>
          <el-table-column prop="code" label="合同编号">
            <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
          </el-table-column>
          <el-table-column prop="name" label="合同名称"></el-table-column>
          <el-table-column prop="contractUser.name" label="发起方" show-overflow-tooltip></el-table-column>
          <el-table-column prop="signStartTime" label="发起时间" show-overflow-tooltip></el-table-column>
          <el-table-column prop="signFinishTime" label="签署完成时间" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" class="uploadIcon" @click="downLoad(scope.row)">
                <span class="img"></span>下载
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="detailFn(scope.row.id)"
                class="detailIcon"
              >
                <span class="imgs"></span>详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="applyFoot" v-if="notData">
          <p class="fl">
            <el-checkbox v-model="checked" class="fl"></el-checkbox>
            <span class="fl add" @click="addFn(2)">申请公证</span>
            <span class="fl add" @click="addFn(1)">司法鉴定</span>
            <span class="fl add" @click="addFn(0)">申请律师服务</span>
          </p>
          <el-pagination
            v-if="showPagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div class="popUp">
      <Dialog
        :visible="dialogVisible"
        :dialogTitle="'申请律师服务'"
        v-on:closeDialog="closeDialog"
        :width="'600px'"
      >
        <div slot="dialog">
          <div class="solicitorBox">
            <solicitor
              @closeDialog="closeDialog"
              @hintMessages="hintMessageFns"
              @closeHints="successMessageFns"
              @dialogVisible="dialogVisibleFn"
              ref="multiples"
            ></solicitor>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="successFulBox"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog"
        :width="'400px'"
      >
        <div slot="dialog">
          <div class="successFulBox">操作成功</div>
        </div>
      </Dialog>
      <Dialog
        :visible="judiciaryBox"
        :dialogTitle="'申请司法鉴定'"
        v-on:closeDialog="closeDialog"
        :width="'600px'"
      >
        <div slot="dialog" id="sfjd">
          <div class="authenticateBox">
            <p class="doingNum">
              您正在将
              <span style="color:#E88078;">{{num}}</span>个证据统一申请司法鉴定
            </p>
            <el-form
              :model="ruleFormjdc"
              :rules="rulesjdc"
              ref="ruleFormjdc"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="申请名称：" prop="comName">
                <el-input v-model="ruleFormjdc.comName" plcaeholder="输入要鉴定合同名称"></el-input>
              </el-form-item>
              <el-form-item label="包含证据文件：">{{num}}</el-form-item>
              <el-form-item label="机构名称：">海存科仪司法鉴定中心</el-form-item>
              <el-form-item label="机构地址：">北京市昌平区龙城北街金域国际中心B座402室</el-form-item>
              <el-form-item class="primaryBox">
                <el-button @click="cancalFn">取消</el-button>
                <el-button
                  type="primary"
                  :disabled="isSubmitIng"
                  @click="submitjdc('ruleFormjdc')"
                >确定</el-button>
              </el-form-item>
            </el-form>
            <p class="hint">申请成功后您可携带本人身份证或企业营业执照前往相应地址现场办理司法鉴定业务</p>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="applyNotar"
        :dialogTitle="'申请公证'"
        v-on:closeDialog="closeDialog"
        :width="'600px'"
      >
        <div slot="dialog">
          <div class="applyNotar">
            <apply
              @closeDialog="closeDialog"
              ref="multiples"
              @hintMessage="hintMessageFn"
              @applyNotar="applyNotarFn"
              @closeHints="successMessageFn"
            ></apply>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="hintMessage"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog"
        :width="'400px'"
        class="hintMessageBox"
      >
        <div slot="dialog">
          <div class="hintMessCon">公证包名已存在</div>
        </div>
      </Dialog>
      <Dialog
        :visible="hintMessages"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog"
        :width="'400px'"
        class="hintMessageBox"
      >
        <div slot="dialog">
          <div class="hintMessCon">选定合同已经申请过律师服务</div>
        </div>
      </Dialog>
      <Dialog
        :visible="hintMessagess"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog"
        :width="'400px'"
        class="hintMessageBox"
      >
        <div slot="dialog">
          <div class="hintMessCon">该合同已经进行过司法鉴定</div>
        </div>
      </Dialog>
      <Dialog
        :visible="successBox"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog"
        :width="'400px'"
        @closeHint="successMessageFn"
        class="hintMessageBox"
      >
        <div slot="dialog">
          <div class="hintMessCon">操作成功</div>
        </div>
      </Dialog>
    </div>
  </div>
</template>

<script>
import Dialog from "@common/Dialog.vue";
import solicitor from "./components/solicitorServices.vue";
import breadcrumb from "@common/Breadcrumb.vue";
import apply from "./components/applyNotar.vue";
import BaseApi from "@lib/baseApi.js";
import {mapState} from "vuex"
import $ from "jquery";
export default {
  data() {
    return {
      hintMessages: false,
      notData: false,
      successBox: false,
      hintMessagess: false,
      messHint: "",
      hintMessage: false,
      showPagination: true,
      currentPage: 1, //默认第一页
      total: 80, //总条数
      pageSizes: [10, 20, 50, 100, 200], //每页展示多少条
      pageSize: 10, //默认第一页展示10条
      tableData: [],
      multipleSelection: [],
      checked: false,
      dialogVisible: false,
      successFulBox: false,
      judiciaryBox: false,
      applyNotar: false,
      // 是否正在提交
      isSubmitIng: false,
      id: [],
      num: 0,
      ruleFormjdc: {
        comName: ""
      },
      rulesjdc: {
        comName: [
          { required: true, message: "请输入申请名称", trigger: "blur" }
        ]
      }
    };
  },

  mounted() {
    this.init();
  },
  
  methods: {
    init() {
      var queryStres = {
        status: "4",
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      BaseApi.createRpcToken("/contract/v2/list", queryStres)
        .then(
          data => {
            this.tableData = data.datas.list.list;
            this.total = data.datas.list.totalRow;
            if (data.datas.list.totalRow > 0) {
              this.notData = true;
            }
            if (data.datas.list.totalRow > 10) {
              this.showPagination = true;
            } else {
              this.showPagination = false;
            }
          },
          data => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    downLoad(row) {
      BaseApi.createRpcToken("/file/download", { id: row.id })
        .then(data => {
          if (data.datas.zipUrl) {
            // var a = document.createElement("a");
            // a.href = data.datas.zipUrl;
            // a.download = data.datas.zipUrl;
            // a.click();
            try {
              var elemIF = document.createElement("iframe");
              elemIF.src = data.datas.zipUrl;
              elemIF.style.display = "none";
              document.body.appendChild(elemIF);
            } catch (e) {}
            // window.open(data.datas.zipUrl);
          } else {
            this.$message.error("下载失败");
          }
        })
        .catch(function(e) {
          errorLog(e);
        });
    },
    dialogVisibleFn(data) {
      this.dialogVisible = data;
    },
    hintMessageFn(data) {
      this.hintMessage = data;
    },
    hintMessageFns(data) {
      this.hintMessages = data;
    },
    successMessageFn(data) {
      this.successBox = data;
    },
    successMessageFns(data) {
      this.successBox = data;
    },
    applyNotarFn(data) {
      this.applyNotar = data;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.init();
    },
    detailFn(id) {
      this.$router.push({
        path: "/personal/sign/detail",
        query: {
          id: id
        }
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.init();
    },
    closeDialog(data) {
      this.dialogVisible = data;
      this.successFulBox = data;
      this.judiciaryBox = data;
      this.applyNotar = data;
      this.successBox = data;
      this.hintMessages = data;
      this.hintMessagess = data;
    },
    addFn(num) {
      if (this.checked == true) {
        if (this.multipleSelection.length > 0) {
          if (num == "0") {
            this.dialogVisible = true;
            this.$nextTick(function() {
              this.$refs.multiples.setData(this.id);
            });
          } else if (num == "1") {
            this.judiciaryBox = true;
          } else {
            this.applyNotar = true;
            this.$nextTick(function() {
              this.$refs.multiples.setData(this.id);
            });
          }
        }
      }
    },
    sifa() {
      var params = {
        expertisePackageName: this.ruleFormjdc.comName,
        expertiseCenterCode: "1",
        expertiseCenterAddress: "北京市昌平区龙城北街金域国际中心B座402室",
        contractCount: this.num,
        contractIds: this.id
      };
      console.log("测试");
      const loading = this.$loading({
        lock: true,
        text: "正在提交",
        target: "#sfjd"
      });
      this.isSubmitIng = true;
      BaseApi.createRpcToken("/Judiciary/addJudiciary", params, "post")
        .then(
          data => {
            if (data.code == "200") {
              this.judiciaryBox = false;
              this.successBox = true;
              setTimeout(() => {
                this.successBox = false;
                this.$router.replace({
                  path: "/personal/serviceHome",
                  query: {
                    flag: "second"
                  }
                });
                this.isSubmitIng = false;
              }, 2000);
            } else if ((data.datas.code = "7001")) {
              this.judiciaryBox = false;
              this.hintMessagess = true;
              setTimeout(() => {
                this.hintMessagess = false;
                this.judiciaryBox = true;
                this.isSubmitIng = false;
              }, 2000);
            } else {
              this.isSubmitIng = false;
            }
            loading.close();
          },
          data => {
            loading.close();
            this.isSubmitIng = false;
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    cancalFn() {
      this.judiciaryBox = false;
    },
    submitjdc(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.sifa();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSelectionChange(val) {
      if (val.length == 0) {
        return;
      }
      if (val.length > 1) {
        this.$refs.multipleTable.toggleRowSelection(val[0], false);
        this.$refs.multipleTable.toggleRowSelection(val[1], false);
      }
      this.num = val.length;
      this.id = val[0].id;
      if (val.length > 0) {
        this.checked = true;
      } else {
        this.checked = false;
      }
      this.multipleSelection = val;
    }
  },
  components: {
    Dialog,
    solicitor,
    apply,
    BaseApi,
    breadcrumb
  },
  computed:{
    ...mapState(['currentInfo']),
  },
   watch:{
    "currentInfo"(data){
       this.init()
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.applyForBox {
  width: 100%;
  height: 100%;
  overflow: scroll;
  .applyForMain {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 3px;
    padding: 20px;
    box-sizing: border-box;
    .applyForCon {
      margin-top: 30px;
      table {
        
        th,
        td {
          vertical-align: middle;
          height: 30px;
          padding: 0;
        }
        th:nth-child(1),
        td:nth-child(1) {
          // width: 29.9%;
        }
        th:nth-child(2),
        td:nth-child(2) {
          // width: 19.5%;
        }
        th:nth-child(3),
        td:nth-child(3) {
          // width: 8%;
        }
        th:nth-child(4),
        td:nth-child(4) {
          // width: 8%;
        }
        th:nth-child(5),
        td:nth-child(5) {
          // width: 13.6%;
        }
        th:nth-child(6),
        td:nth-child(6) {
          // width: 12%;
        }
        th:nth-child(7),
        td:nth-child(7) {
          // width: 9%;
        }
        th {
          font-size: 14px;
          color: #505050;
          text-align: center;
          background: #f9f9f9;
        }
        td {
          font-size: 12px;
          color: #969696;
          text-align: center;
        }
        .cell {
          text-align: center;
          line-height: 30px;
          padding: 0;
        }
        .uploadIcon:hover {
          color: #e88078;
          .img {
            background: url("../../../assets/images/service/down_icon_hov.png");
          }
        }
        .detailIcon:hover {
          color: #e88078;
          .imgs {
            background: url("../../../assets/images/service/details_icon_hov.png  ");
          }
        }
        .el-button {
          color: #969696;
          .img {
            display: inline-block;
            width: 14px;
            height: 14px;
            background: url("../../../assets/images/service/down_icon_nor.png");
            vertical-align: middle;
            margin-right: 3px;
          }
          .imgs {
            display: inline-block;
            width: 14px;
            height: 14px;
            background: url("../../../assets/images/service/details_icon_nor.png");
            vertical-align: middle;
            margin-right: 3px;
          }
        }
        .el-button:nth-child(1) {
          margin-right: 20px;
        }
        th {
          .el-checkbox {
            display: none;
          }
        }
        .el-checkbox__inner:hover {
          border-color: #e88078;
        }
        .el-checkbox__input.is-focus .el-checkbox__inner {
          border-color: #dcdfe6;
        }
        .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #e88078;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner {
          border-color: #e88078;
          background: #e88078;
        }
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          border-color: #dcdfe6;
          background: #fff;
          display: none;
        }
      }
      .applyFoot {
        .el-pagination {
          float: right;
          margin-top: 20px;
        }
        .el-checkbox__inner:hover {
          border-color: #e88078;
        }
        .el-checkbox__input.is-focus .el-checkbox__inner {
          border-color: #dcdfe6;
        }
        .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #e88078;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          border-color: #e88078;
          background: #e88078;
        }
      }
      .pageDev {
        float: right;
        margin-top: 20px;
      }
      p {
        margin-top: 20px;
        height: 32px;
        line-height: 32px;
        .el-checkbox__inner {
          vertical-align: middle;
          margin: 10px 17px 19px;
        }
        .add {
          display: inline-block;
          padding: 0 20px;
          border: 1px solid #db4437;
          height: 32px;
          line-height: 32px;
          text-align: center;
          margin-right: 20px;
          font-size: 12px;
          color: #db4437;
        }
        .add:hover {
          color: #fff;
          border: 1px solid #a5303d;
          background-color: #a5303d;
        }
      }
    }
  }
  .successFulBox {
    height: 200px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #646464;
  }
  .authenticateBox {
    height: 319px;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .doingNum,
    .hint {
      width: 100%;
      text-align: center;
      height: 32px;
      line-height: 32px;
      background-color: #f0f0f0;
      font-size: 12px;
      color: #969696;
    }
    .hint {
      width: 473px;
      margin-top: 20px;
    }
    .el-form {
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__label {
          font-size: 12px;
          color: #919191;
          line-height: 30px;
          padding: 0;
        }
        .el-form-item__content {
          line-height: 30px;
          .el-input {
            .el-input__inner {
              width: 170px;
              height: 30px;
              line-height: 30px;
              border-radius: 0;
              border-color: #c8c8c8;
            }
          }
          .el-button {
            width: 100px;
            height: 32px;
            line-height: 32px;
            padding: 0;
            font-size: 12px;
            background-color: #fff;
            color: #646464;
            border: 1px solid #c8c8c8;
            border-radius: 0;
          }
          .el-button--primary {
            color: #db4437;
            border-color: #db4437;
            float: left;
          }
          .el-button:nth-child(2) {
            float: right;
          }
        }
      }
      .el-form-item:nth-child(1) {
        margin-top: 27px;
        margin-bottom: 11px;
      }
      .primaryBox {
        margin-top: 20px;
        .el-form-item__content {
          margin-left: 0 !important;
        }
        .el-button:first-child:hover {
          color: #db4437;
          border-color: #db4437;
        }
        .el-button:last-child:hover {
          color: #fff;
          border-color: #a5303d;
          background-color: #a5303d;
        }
      }
    }
    .el-form-item.is-required:not(.is-no-asterisk)
      > .el-form-item__label:before {
      content: "";
    }
  }
  .hintMessageBox {
    .hintMessCon {
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
